import { NgModule, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BpTabsComponent } from './tabs.component';
import { BpTabDirective } from './tab.directive';

const DECLARES = [
    BpTabsComponent,
    BpTabDirective
];

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: DECLARES,
  exports: DECLARES
})
export class BpTabsModule {
}
